(function (angular) {
	'use strict';

	var planVariantSelectObject = {
		templateUrl: [
			'STATIC_BASE_PATH',
			templateUrlFunction
		],
		bindings: {
			investmentStrategy: '@',
			submitCallback: '&'
		},
		controller: [
			'$filter',
			'$q',
			'ModalFactory',
			'planFactory',
			'ServiceLevelFactory',
			'STATIC_BASE_PATH',
			PlanVariantSelectFunction
		],
		controllerAs: 'planVariantSelect'
	};

	angular
		.module('planVariantSelectModule')
		.component('planVariantSelect', planVariantSelectObject);

	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/service-level/plan-variant-select.html';
	}

	function PlanVariantSelectFunction(
		$filter,
		$q,
		ModalFactory,
		planFactory,
		ServiceLevelFactory,
		STATIC_BASE_PATH
	) {
		var planVariantSelect = this;

		function getActiveProjectCount(allocationByRating) {
			var activeProjectCount = 0;

			angular.forEach(allocationByRating, function(rating) {
				activeProjectCount += rating.properties.length;
			});

			return activeProjectCount;
		}

		function handleContinue() {
			var selectedPlanId = planVariantSelect.plusPlanSelected ? planVariantSelect.plusPlanVariant.planId : planVariantSelect.standardPlanVariant.planId;
			planVariantSelect.submitCallback({riaPlanId: selectedPlanId});
		}

		function openFormK1AcknowledgmentModal() {
			ModalFactory.showModal({
				templateUrl: STATIC_BASE_PATH + '/static/html/shared/modal/form-k1-acknowledgement-modal.html',
				controller: 'FormK1AcknowledgementModal',
				controllerAs: 'formK1AcknowledgementModal',
				inputs: {
					proceed: function() {
						handleContinue();
					}
				}
			}).then(function(modal) {
				modal.close.then(function() {
					planVariantSelect.formSubmitted = false;
				});
			});
		}

		planVariantSelect.checkIfShouldShowK1Message = function() {
			if (planVariantSelect.plusPlanSelected) {
				openFormK1AcknowledgmentModal();
			} else {
				handleContinue();
			}
		};

		planVariantSelect.$onInit = function() {
			planVariantSelect.loading = true;

			$q.all({
				plusVariantId: ServiceLevelFactory.getRiaPlanByStrategyAndType(planVariantSelect.investmentStrategy, 'STANDARD_PLUS'),
				standardVariantId: ServiceLevelFactory.getRiaPlanByStrategyAndType(planVariantSelect.investmentStrategy, 'STANDARD'),
				riaPlans: planFactory.getPlanData(['STANDARD', 'STANDARD_PLUS'])
			})
				.then(function(response) {
					var riaPlanPlusVariantId = parseInt(response.plusVariantId);
					var riaPlanStandardVariantId = parseInt(response.standardVariantId);
					var riaPlanData = response.riaPlans.data;

					planVariantSelect.plusPlanVariant = $filter('filter')(riaPlanData, {planId: riaPlanPlusVariantId}, true)[0];
					planVariantSelect.plusPlanVariant.activeProjectCount = getActiveProjectCount(planVariantSelect.plusPlanVariant.allocationByRating);

					planVariantSelect.standardPlanVariant = $filter('filter')(riaPlanData, {planId: riaPlanStandardVariantId}, true)[0];
					planVariantSelect.standardPlanVariant.activeProjectCount = getActiveProjectCount(planVariantSelect.standardPlanVariant.allocationByRating);

					planVariantSelect.loading = false;
				});
		};
	}
})(window.angular);
